var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "", "offset-xs2": "" } },
            [
              _c(
                "v-container",
                { attrs: { "grid-list-xl": "", fluid: "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h1", { staticClass: "display-1" }, [
                          _vm._v("TomaxZone Management")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs6: "" } },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-container",
                                { attrs: { "grid-list-xl": "", fluid: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c(
                                            "h2",
                                            { staticClass: "headline" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.AddEdit) +
                                                  " TomaxZone"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            attrs: {
                                              type: "Number",
                                              label: "TomaxZone"
                                            },
                                            model: {
                                              value: _vm.tomaxZone,
                                              callback: function($$v) {
                                                _vm.tomaxZone = $$v
                                              },
                                              expression: "tomaxZone"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            attrs: { label: "Ship Via" },
                                            model: {
                                              value: _vm.shipVia,
                                              callback: function($$v) {
                                                _vm.shipVia = $$v
                                              },
                                              expression: "shipVia"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            attrs: {
                                              type: "Number",
                                              label: "Other (Days)"
                                            },
                                            model: {
                                              value: _vm.otherDays,
                                              callback: function($$v) {
                                                _vm.otherDays = $$v
                                              },
                                              expression: "otherDays"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            attrs: {
                                              type: "Number",
                                              label: "Shutter (Days)"
                                            },
                                            model: {
                                              value: _vm.shutterDays,
                                              callback: function($$v) {
                                                _vm.shutterDays = $$v
                                              },
                                              expression: "shutterDays"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.tomaxZoneID
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    large: "",
                                                    color: "primary"
                                                  },
                                                  on: {
                                                    click: _vm.updateTomaxZone
                                                  }
                                                },
                                                [_vm._v("Edit TomaxZone")]
                                              )
                                            : _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    large: "",
                                                    color: "primary"
                                                  },
                                                  on: {
                                                    click: _vm.addTomaxZone
                                                  }
                                                },
                                                [_vm._v("Add TomaxZone")]
                                              ),
                                          _vm._v(" "),
                                          _vm.tomaxZoneID
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    large: "",
                                                    color: "primary"
                                                  },
                                                  on: { click: _vm.clearFields }
                                                },
                                                [_vm._v("Cancel")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs6: "" } },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-container",
                                { attrs: { "grid-list-xl": "", fluid: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c("v-data-table", {
                                            attrs: {
                                              headers: _vm.headers,
                                              items: _vm.tomaxzones
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "items",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "td",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.editTomaxZone(
                                                              props.item._id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.tomaxZone
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.editTomaxZone(
                                                              props.item._id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.shipVia
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.editTomaxZone(
                                                              props.item._id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            Other - " +
                                                            _vm._s(
                                                              props.item
                                                                .otherDays
                                                            )
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                            Shutter - " +
                                                            _vm._s(
                                                              props.item
                                                                .shutterDays
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _c(
                                                        "button",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.deleteTomaxZone(
                                                                props.item._id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("Delete")]
                                                      )
                                                    ])
                                                  ]
                                                }
                                              }
                                            ])
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-snackbar",
            {
              attrs: { dark: "", top: "", timeout: 3000 },
              model: {
                value: _vm.snackbar,
                callback: function($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar"
              }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.popupText) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.snackbar = false
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-795286ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-795286ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/TomaxZones.vue
// module id = null
// module chunks = 